import { render, staticRenderFns } from "./KnowledgeSection.vue?vue&type=template&id=d90a093e&scoped=true"
import script from "./KnowledgeSection.vue?vue&type=script&lang=js"
export * from "./KnowledgeSection.vue?vue&type=script&lang=js"
import style0 from "./KnowledgeSection.vue?vue&type=style&index=0&id=d90a093e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d90a093e",
  null
  
)

export default component.exports